import { useEffect, useState } from "react";
import api from "../../../services/api";
import { TablePage } from "../../../containers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark, faGrip, faPencil, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import DialogConfirm from "../../../components/DialogConfirm";
import toastOptions from "../../../utils/toastOptions";
import { toast } from "react-toastify";
import IEventDetail from "../../../models/IEventDetail";
import IDeleteDTO from "../../../models/IDeleteDTO";
import { authenticationService } from "../../../services/auth.service";

export default function EventList() {
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState<boolean>(false);
  const [pageNo, setPageNo] = useState<number>(1);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [ixClosing, setIxClosing] = useState<number>(-1);
  const [eventSelected, setEventSelected] = useState<IEventDetail>();
  const [totalEvents, setTotalEvents] = useState<number>(0);

  const columns = [
    {
      name: "Evento",
      sortable: true,
      grow: 2,
      cell: (row: any) => <div>
        <span>{row.name}</span>
        {!row.closeDate ? <span className="uk-badge uk-badge-success uk-margin-small-left">Ativo</span> : <span className="uk-badge uk-badge-default uk-margin-small-left">Encerrado</span>}
      </div>
    },
    {
      name: 'Ações',
      button: true,
      sortable: false,
      cell: (row: IEventDetail, index: number) => (
        <div className='uk-flex uk-flex-between'>
          <Link to={`/eventos/${row.id}`} uk-tooltip={`title: ${canChange(row) ? 'Editar' : 'Ver'} Evento`}
            className='uk-margin-small-right'
          >
            <FontAwesomeIcon icon={canChange(row) ? faPencil : faSearch} />
          </Link>
          <Link to={`/eventos/${row.id}/dashboard`} uk-tooltip="title: Ir para Dashboard do Evento" 
            className='uk-margin-small-right'
          >
            <FontAwesomeIcon icon={faGrip} />
          </Link>
          {canChange(row) && <>
            { ixClosing === row.id ? 
              <div className="uk-margin-small-left" uk-spinner="true; ratio:0.5"></div> :
              <a href="#" 
                onClick={(ev) => {ev.preventDefault(); setOpenConfirm(true); setEventSelected(row); }}
                uk-tooltip="title: Fechar Evento" 
                className='uk-margin-small-right'
              >
                <FontAwesomeIcon icon={faCircleXmark} />
              </a>
            }
          </>}
        </div>
      )
    }
  ];

  const canChange = (event: IEventDetail) => {
    if (authenticationService.isReadOnly()) return false;
    if (!event.closeDate) return true;
    return false;
  }

  const fetchEvents = async (page: number, limit: number) => {
    try {
      let params = {
        page: page,
        limit: limit
      } as any;

      const response = await api.get(`events`, { params: params });

      setPageNo(page);
      setTotalEvents(response.data.total);

      return response;
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.error(m, toastOptions);
      });
      return { data: [], total: 0 };
    }
  };

  const handleCloseEvent = async (confirmationCode: string) => {
    if (!eventSelected) return;

    if (!confirmationCode) {
      toast.warning('Informe a senha', toastOptions);
      return;
    }

    const dto = {} as IDeleteDTO;
    dto.confirmationCode = confirmationCode;
    dto.idDelete = +(eventSelected.id);

    setOpenConfirm(false);

    setIxClosing(dto.idDelete);
    try {
      await api.post(`events/${eventSelected?.id}/close`, dto);
      toast.success("Evento fechado com sucesso!", toastOptions);
      setRefresh(!refresh);
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.warning(m, toastOptions);
      });
    } finally {
      setIxClosing(-1);
    }
  };

  return (<div id="page-event-list">
    <TablePage 
      title={"Eventos"}
      columns={columns}
      fetch={fetchEvents}
      refresh={refresh}
      messageEmpty={<span>Nenhum <b>evento</b> encontrado!</span>}
      showSubHeader
      totalRecords={totalEvents}
      labelTotalRecords={`${totalEvents} ${totalEvents === 1 ? "Evento" : "Eventos"}`}
      pageNo={pageNo}
      showAddButton={!authenticationService.isReadOnly()}
      handleAdd={() => navigate('/eventos/novo')}
    />
    <DialogConfirm 
      open={openConfirm}
      text={['Deseja fechar o evento?', 'Ao informar a senha ele será fechado e não pode ser reaberto']}
      confirmTextLabel="Confirme a senha para fechar o evento"
      afterClose={()=> { setOpenConfirm(false); setRefresh(!refresh); setEventSelected(undefined); }}
      handleConfirmation={(confirmation: any) => handleCloseEvent(confirmation)}
    />
  </div>);
}